import { useTranslation } from 'react-i18next'
import { Alert } from 'baseui/icon'
import { StatefulTooltip } from 'baseui/tooltip'
import { pulseTooltipOverrides } from '@/shared/components/PulseScope/styled-components'
import useUnsavedChangesBadge from '../UnsavedChangesBadge/useUnsavedChangesBadge'
import { PulseClientTabTitleText, PulseUnsavedIcon } from '../styled-components'

const PulseClientTabTitle = () => {
  const { t } = useTranslation()
  const { hidden, label, onKeyDown } = useUnsavedChangesBadge()

  if (hidden) return <>{t('common:client')}</>

  return (
    <PulseClientTabTitleText>
      {t('common:client')}
      <StatefulTooltip content={label} popoverMargin={8} overrides={pulseTooltipOverrides}>
        <PulseUnsavedIcon role='img' tabIndex={0} aria-label={label} onKeyDown={onKeyDown}>
          <Alert size={14} color='currentColor' />
        </PulseUnsavedIcon>
      </StatefulTooltip>
    </PulseClientTabTitleText>
  )
}

export default PulseClientTabTitle
